import * as api from 'services/api';
import { addError } from 'actions/error';

export const getConsultants = (query) => (dispatch) =>
  api.get(`consultants?${query}`, 'GET_SIMILAR_CONSULTANTS', dispatch).catch((error) => {
    dispatch(addError(new Error('GET_SIMILAR_CONSULTANTS_ERROR')));
    // Resolve with null on failure so callers get a checkable value.
    return null;
  });

export const getConsultantInfo = (id) => (dispatch) =>
  api.get(`consultants/${id}`, 'GET_CONSULTANT_INFO', dispatch).catch((error) => {
    dispatch(addError(new Error('GET_CONSULTANT_INFO_ERROR')));
    // Resolve with null on failure so callers get a checkable value.
    return null;
  });
